
import {
  defineComponent, onMounted, ref,
} from 'vue';

export default defineComponent({
  emits: ['hide'],
  props: {
    hideBottomDecoration: { type: Boolean, default: false },
    hideTopDecoration: { type: Boolean, default: false },
    positionData: { type: Object, required: true },
  },
  setup(props, { emit }) {
    const mouseHeight = ref(0);

    function getHeight() {
      const screenHeight = window.innerHeight;
      const clickHeight = props.positionData?.y;
      if (screenHeight - clickHeight < 191) {
        mouseHeight.value = clickHeight - 191;
      } else {
        mouseHeight.value = clickHeight + 16;
      }
    }

    onMounted(() => {
      getHeight();
    });

    return {
      emit,
      getHeight,
      mouseHeight,
    };
  },
});
